import { StrategyEx } from "@front/m19-models";
import { Filter, FilterCategory } from "@m19-board/shared/compact-filter/compact-filter.component";

export type StrategyGridFilterCategory = FilterCategory.DspFunnel;

export function passesStrategyGridFilters(
  strategy: StrategyEx,
  filters: Filter<StrategyGridFilterCategory>[],
): boolean {
  if (!strategy.isDspStrategy()) return true;
  return filters.every((filter) => filter.values.length === 0 || filter.values.includes(strategy.dspFunnel!));
}
